import { chartColors, fontSize } from "./design";

const escapeHtml = (value) => String(value).replace(/[&<>"']/g, (character) => ({
  "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;",
})[character]);

export const formatChartFilterLabel = (name, subtitle) => {
  if (!subtitle) return escapeHtml(name);
  return `<span style="display:inline-block;white-space:nowrap">${escapeHtml(name)}<br/><span style="color:${chartColors[9]};font-size:${fontSize.filterLabel}px;font-weight:normal;white-space:nowrap">${escapeHtml(subtitle)}</span></span>`;
};
